<template>
  <div>
    排行頁面
  </div>
</template>

<script>
  export default {

  }
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// rank.vue?565535b8